import React, { Component } from 'react'
import PropTypes from 'prop-types'
import PublicHolidayForm from './PublicHolidayForm.jsx'
//import _ from 'lodash'

class AddPublicHolidayComponent extends Component{
  componentDidMount() {
    this.props.fetchData()
  }

  render() {
    if (this.props.publicholiday.publicholiday) {
      return <div><PublicHolidayForm publicholiday={this.props.publicholiday}></PublicHolidayForm></div>
    }
    return <div></div>
  }
}

AddPublicHolidayComponent.propTypes = {
  fetchData: PropTypes.func.isRequired,
  publicholiday: PropTypes.object.isRequired,
}

export default AddPublicHolidayComponent
